/**
 * The feature kinds that CODE knows about, which is not the same set as the rows in FeatureKind.
 *
 * Hand-written on purpose. enums.ts is generated wholesale from the metadata's enumTypes
 * section, so an enum written there survives only until the next regen - which is exactly how
 * this one was lost once already.
 *
 * It is not generated because FeatureKind is an operator-editable table: the References ->
 * Feature Types page adds rows, and ids 4 and up have no member here. Typing FeatureKind.Id as
 * a closed enum would make the key lie about what the table can hold. These are named constants
 * for the kinds that earn special handling, nothing more - a kind with no member still groups
 * features and can still be required of a manufacturer.
 *
 * Adding a member is only ever half the job: the matching row must exist in FeatureKind, and
 * the C# FeatureKindEnum must gain the same member with the same number.
 */
export enum FeatureKindEnum {
  /** An apparel size list. Alpha, waist-and-inseam, Scrubs, and 'No size'. */
  Size = 1,
  /** A color list. */
  Color = 2,
  /** Where a decoration goes. Nothing maps here yet; named so that it can. */
  Position = 3,
  /** Genuinely neither - Units, Yardage, Hours. The default. */
  Other = 99,
}
